import { WithStyles } from "@material-ui/core";
import * as React from "react";
import { withStyles } from "@material-ui/core/styles";
import { styles } from "./Footer.styles";
import moment from "moment";
import { NavLink } from "react-router-dom";
import InstagramIcon from "@material-ui/icons/Instagram";
import YouTubeIcon from "@material-ui/icons/YouTube";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import { useTranslation } from "react-i18next";

export interface IFooterProps extends WithStyles<typeof styles> {
}


const FooterPure: React.FunctionComponent<IFooterProps> = ({classes}: IFooterProps) => {
    const {t} = useTranslation();
    return <>
        <div className={classes.root}>
            <div className={classes.content}>
                <ul className={classes.navSocials}>
                    <li>
                        <a title={`Link opens external web page https://www.linkedin.com/company/deutsche-borse`} target="_blank" rel="noreferrer"
                           href="https://www.linkedin.com/company/deutsche-borse">
                            <LinkedInIcon />
                        </a>
                    </li>
                    <li>
                        <a title={`Link opens external web page https://www.instagram.com/deutscheboersegroup/`} target="_blank" rel="noreferrer"
                           href="https://www.instagram.com/deutscheboersegroup/">
                            <InstagramIcon />
                        </a>
                    </li>
                    <li>
                        <a title={`Link opens external web page https://www.youtube.com/user/deutscheboersegroup`} target="_blank" rel="noreferrer"
                           href="https://www.youtube.com/user/deutscheboersegroup">
                            <YouTubeIcon />
                        </a>
                    </li>
                </ul>
                <div className={classes.elements}>
                    <ul>
                        <li>
                            <NavLink to={"/intellectual-property-rights-and-rights-of-use"} key="rights">
                                <span>© {moment().format("YYYY")} Gruppe Deutsche Börse</span></NavLink>
                        </li>
                        <li><NavLink to={"/terms-and-conditions"}
                                     key="terms-conditions"><span>Terms and Conditions</span></NavLink></li>
                        <li><NavLink to={"/imprint"} key="imprint"><span>{t("footer.imprint.title")}</span></NavLink></li>
                        <li><NavLink to={"/disclaimer"} key="disclaimer"><span>{t("footer.disclaimer.title")}</span></NavLink></li>
                        <li><NavLink to={"/privacy-notice"} key="privacy-notice"><span>{t("footer.privacy.title")}</span></NavLink></li>
                        <li><NavLink to={"/trademarks"} key="trademarks"><span>{t("footer.trademarks.title")}</span></NavLink></li>
                    </ul>
                </div>
            </div>
        </div>
    </>;
};

export const Footer = withStyles(styles)(FooterPure);
